import { motion } from "framer-motion";

export default function Transition({ label }) {
  return (
    <motion.div
      className="pointer-events-none fixed inset-0 z-[90]"
      data-testid="scene-transition"
    >
      <motion.div
        className="absolute inset-0 bg-[#150F0C]"
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "-100%" }}
        transition={{ duration: 0.6, ease: [0.83, 0, 0.17, 1] }}
      />
      <motion.div
        className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-b from-terra via-[#6E3226] to-[#4A221A]"
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "-100%" }}
        transition={{ duration: 0.6, ease: [0.83, 0, 0.17, 1], delay: 0.07 }}
      >
        <motion.span
          className="mb-4 h-1.5 w-1.5 rounded-full bg-alpana/90"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ delay: 0.35, duration: 0.3 }}
        />
        <motion.span
          className="px-6 text-center font-display text-4xl text-alpana drop-shadow-[0_2px_18px_rgba(0,0,0,0.45)] sm:text-6xl"
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ delay: 0.32, duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        >
          {label}
        </motion.span>
        <motion.span
          className="mt-4 font-latin text-xs italic tracking-[0.3em] text-alpana/70"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ delay: 0.5, duration: 0.35 }}
        >
          চলুন, ভেতরে যাই
        </motion.span>
      </motion.div>
    </motion.div>
  );
}
